export const searchBoxStyle = {
    placeholder: {
        style: {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            width: '100%',
            color: '#2E1884'
        } 
    },
    text: {
        input: { 
            color: '#2E1884'
        },
    },
    border: {
        "& .MuiOutlinedInput-root": {color: '#2E1884'},
        "& .MuiOutlinedInput-root.Mui-focused": {
          "& > fieldset": { borderColor: "orange" },
        },
    }

}; 